import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_PROJECT_ROUTE_NAME = Symbol('admin.settings.project');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_PROJECT = Symbol('general-settings.project');

export const SETTINGS_PROJECT_URL = 'admin/project_settings/list';
export const SETTINGS_PROJECT_SAVE_URL = 'admin/project_settings/save';
export const SETTINGS_PROJECT_INTERFACE_LOCALES_SAVE_URL = 'admin/project_settings/save_interface_locales';
export const SETTINGS_PROJECT_CREATIVE_LOCALES_SAVE_URL = 'admin/project_settings/save_creative_locales';

export const SETTINGS_PROJECT_QUERY_KEY = 'general-settings.project.settings';
export const SETTINGS_PROJECT_SAVE_QUERY_KEY = 'general-settings.project.settings.save';
export const SETTINGS_PROJECT_INTERFACE_LOCALES_SAVE_QUERY_KEY = 'general-settings.project.interface-locales.save';
export const SETTINGS_PROJECT_CREATIVE_LOCALES_SAVE_QUERY_KEY = 'general-settings.project.creative-locales.save';

export const ADMIN_GENERAL_SETTINGS_PROJECT_PERMISSIONS = {
  PROJECTSETTINGS_EDIT: new Permission(PermissionsList.admin.PROJECTSETTINGS_EDIT),
};
